import React, { useEffect, useMemo, useState } from 'react'
import { debounce } from 'lodash'
import { Link } from "react-router-dom"
import { Col, Input, Row } from 'reactstrap'
import AdvancedFilters from '../Filters/AdvancedFilters'
import AdvancedFiltersTrigger from '../Filters/AdvancedFiltersTrigger'
import AppliedAdvancedFilters from '../Filters/AppliedAdvancedFilters'
import { useAdvancedFilters } from '../Filters/filterUrl'
import { countVisibleFilters } from '../Filters/presetFilters'

const FILTER_ENTITIES = {
    'automations': 'automation',
    'execution-logs': 'automation_execution_log',
}

function AutomatelyAdvancedFiltersControl({ entity }) {
    const [isOpen, setIsOpen] = useState(false)
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()

    useEffect(() => setIsOpen(false), [entity])

    return (
        <>
            <AdvancedFiltersTrigger
                compact
                count={countVisibleFilters(undefined, advancedFilters)}
                onClick={() => setIsOpen((currentValue) => !currentValue)}
            />
            {isOpen && (
                <AdvancedFilters
                    isOpen
                    onClose={() => setIsOpen(false)}
                    entity={entity}
                    context={null}
                    activeFilters={advancedFilters}
                    onApply={setAdvancedFilters}
                />
            )}
        </>
    )
}

const AutomatelyListHeader = ({ activeTab, searchTerm = '', setSearchTerm, showFilters = true, showSearch = true, showCreateAction = true, searchPlaceholder, searchAriaLabel }) => {
    const [searchInput, setSearchInput] = useState(searchTerm)
    const isExecutionLogsView = activeTab === 'execution-logs'
    const filterEntity = FILTER_ENTITIES[activeTab]
    const activeSearchPlaceholder = searchPlaceholder || (isExecutionLogsView ? 'Search execution logs' : 'Search automations')
    const activeSearchAriaLabel = searchAriaLabel || activeSearchPlaceholder
    const updateSearchFilter = useMemo(() => debounce((value) => {
        setSearchTerm?.(value)
    }, 400), [setSearchTerm])

    useEffect(() => {
        return () => updateSearchFilter.cancel()
    }, [updateSearchFilter])

    useEffect(() => {
        setSearchInput(searchTerm)
    }, [activeTab, searchTerm])

    const handleSearchChange = (event) => {
        const { value } = event.target
        setSearchInput(value)
        updateSearchFilter(value)
    }

    return (
        <header className="automately-list-header">
            <Row className="automately-list-toolbar pb-2">
                <Col xs="12" md="6" className="automately-search-column">
                    <div className="automately-search-filter-group">
                        {showSearch && <label className="automately-search">
                            <Input
                                type="search"
                                name="searchTerm"
                                placeholder={activeSearchPlaceholder}
                                aria-label={activeSearchAriaLabel}
                                onChange={handleSearchChange}
                                value={searchInput}
                            />
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </label>}
                        {showFilters && <AutomatelyAdvancedFiltersControl entity={filterEntity} />}
                    </div>
                </Col>

                <Col xs="12" md="6" className="automately-list-actions">
                    {showCreateAction && (
                        <Link to="/automations/new">
                            New Automation <i className="fa fa-plus-square" aria-hidden="true"></i>
                        </Link>
                    )}
                </Col>
            </Row>
            {showFilters && (
                <Row>
                    <Col xs="12" className="search-filter-container mb-2">
                        <AppliedAdvancedFilters entity={filterEntity} context={null} />
                    </Col>
                </Row>
            )}
        </header>
    )
}

export default AutomatelyListHeader
